import * as api from '../api';
import { PURGE } from 'redux-persist';

const moment = require('moment-timezone');
const dateFormat = 'MMMM D, YYYY h:mm a';

//actions
export const GET_FINANCIAL_REPORT = 'GET_FINANCIAL_REPORT';
export const GET_FINANCIAL_REPORT_TOTALS = 'GET_FINANCIAL_REPORT_TOTALS';
export const CLEAR_FINANCIAL_REPORT = 'CLEAR_FINANCIAL_REPORT';

//action creators
export const getReport = (token, fleetId, startDate, endDate, reportType, operatorId) => {
  return (dispatch) => {
    return api
      .getReport(token, fleetId, startDate, endDate, reportType, operatorId)
      .then((result) => {
        dispatch({
          type: GET_FINANCIAL_REPORT,
          report: result,
        });
        return result;
      })
      .catch((error) => {
        throw error;
      });
  };
};

export const getFinancialReport = (token, fleetId, startDate, endDate) => {
  return getReport(token, fleetId, startDate, endDate, 'financial');
};

export const getFinancialReportTotals = (token, fleetId, startDate, endDate) => {
  return (dispatch) => {
    return api
      .getFinancialReportTotals(token, fleetId, startDate, endDate)
      .then((result) => {
        dispatch({
          type: GET_FINANCIAL_REPORT_TOTALS,
          totals: result,
        });
        return result;
      })
      .catch((error) => {
        throw error;
      });
  };
};

export const clearFinancialReport = () => ({ type: CLEAR_FINANCIAL_REPORT });

// reducer
export default (state = { report: [], totals: { metrics: null } }, action) => {
  switch (action.type) {
    case GET_FINANCIAL_REPORT:
      // Handle the case where action.report is an object with a report property
      let reportData = [];
      
      if (action.report && typeof action.report === 'object') {
        // If action.report is an object with a report property that is an array
        if (action.report.report && Array.isArray(action.report.report)) {
          reportData = action.report.report;
        } 
        // If action.report itself is an array (for backward compatibility)
        else if (Array.isArray(action.report)) {
          reportData = action.report;
        }
      }
      
      const report = reportData.map((ride) => {
        const formattedStart = moment(ride.start_time).format(dateFormat);
        return {
          ...ride,
          formatted_start_time: formattedStart,
        };
      });
      return { ...state, report };

    case GET_FINANCIAL_REPORT_TOTALS:
      return { ...state, totals: action.totals };

    case CLEAR_FINANCIAL_REPORT:
    case PURGE:
      return { report: [], totals: { metrics: null } };

    default:
      return state;
  }
};


